const normalizeSearchParamValue = (value: unknown) => {
  if (value == null) {
    return null
  }

  if (Array.isArray(value)) {
    return value.length > 0 ? String(value[0]) : null
  }

  return String(value)
}

export const getSearchParam = (
  queryString: string | URLSearchParams | Record<string, unknown>,
  name: string,
) => {
  const normalizedName = name.toLowerCase()

  if (
    typeof queryString === 'string' ||
    queryString instanceof URLSearchParams
  ) {
    const searchParams =
      queryString instanceof URLSearchParams
        ? queryString
        : new URLSearchParams(queryString)

    for (const [key, value] of searchParams.entries()) {
      if (key.toLowerCase() === normalizedName) {
        return value
      }
    }

    return null
  }

  for (const [key, value] of Object.entries(queryString)) {
    if (key.toLowerCase() === normalizedName) {
      return normalizeSearchParamValue(value)
    }
  }

  return null
}
